export class WhereParams {
    public fieldName: string;
    public value: any;
    public allowWildcards: boolean = false;
    public nestedPath: boolean = false;
    public exact;
}
